import { AssetPreview } from 'framework-asset-preview-lib';
import { FORM_OBJECT_TYPE } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const DetailsPanel = ({
  objectId,
  setId
}) => /*#__PURE__*/_jsx(AssetPreview, {
  applicationId: "forms-ui",
  objectId: objectId,
  objectType: FORM_OBJECT_TYPE,
  onClose: () => {
    setId(0);
  },
  previewType: "sidepanel"
});
export default DetailsPanel;